export default __webpack_public_path__ + "static/media/html.3d46777d.png";